<template>
  <div>
    <memlist-card v-if="!done_onboarding_company && !current_onboarding_company">
      <m-row>
        <m-col lg="12" class="text-center" >
          <memlist-spinner />
        </m-col>
      </m-row> 
      
    </memlist-card>

    <StripeOnboardingComponent />

    <memlist-card v-if="done_onboarding_company">
      <memlist-inline-alert variant="success">Ni har redan avklarat er onboarding!</memlist-inline-alert>
    </memlist-card>
    <div v-else-if="current_onboarding_company">
      <div class="onboarding_wizard">

        <!-- Wizard Navigation: show step indicators -->
        <div class="wizard_nav">
          <div class="wizard_progress">
            <div class="wizard_progress_bar" :style="{ width: `${(current_page_index) / (pages.length - 1) * 100}%` }"></div>
          </div>

          <div class="wizard_steps">
            <div
              v-for="(page, index) in pages"
              :key="index"
              class="wizard_step_container"
            >
              <div
                class="wizard_step"
                :class="{
                  active: current_page_index === index,
                  completed: current_page_index > index
                }"
              >
                <span v-if="current_page_index > index">✔</span>
                <span v-else>{{ index + 1 }}</span>
              </div>
              
            </div>
          </div>
        </div>

        <div class="wizard-page">
          <memlist-card>
            <!-- Dynamic component for the current page -->
            <component
              :is="current_page_component"
              :onboarding_data="current_onboarding_company.onboarding_data"
              :company="company"
              @update_data="update_data"
              @next_page="next_page"
              @prev_page="prev_page"
              @finished="finished"
            />
          </memlist-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex';

// Import all step components
import OnboardingPage1 from './pages/OnboardingPage1.vue'
import OnboardingPage2 from './pages/OnboardingPage2.vue'
import OnboardingPage3 from './pages/OnboardingPage3.vue'
import OnboardingPage4 from './pages/OnboardingPage4.vue'
import OnboardingPage5 from './pages/OnboardingPage5.vue'
import OnboardingPage6 from './pages/OnboardingPage8.vue'
import OnboardingPage7 from './pages/OnboardingPage6.vue'
import OnboardingPage8 from './pages/OnboardingPage7.vue'
import OnboardingPage9 from './pages/OnboardingPage9.vue'
import OnboardingPage10 from './pages/OnboardingPage10.vue'
import OnboardingPage11 from './pages/OnboardingPage11.vue'
import OnboardingPage12 from './pages/OnboardingPage12.vue'
import StripeOnboardingComponent from '@/view/components/StripeOnboardingComponent.vue';

export default {
  name: 'onboarding_wizard',
  components: {
    OnboardingPage1,
    OnboardingPage2,
    OnboardingPage3,
    OnboardingPage4,
    OnboardingPage5,
    OnboardingPage6,
    OnboardingPage7,
    OnboardingPage8,
    OnboardingPage9,
    OnboardingPage10,
    OnboardingPage11,
    OnboardingPage12,
    StripeOnboardingComponent
  },
  data() {
    return {

      company: null,
      registration: null,
      done_onboarding_company: null,
      current_onboarding_company: null,
      current_page_index: 0,
      // Store imported components directly in the pages array.
      pages: [
        OnboardingPage1,
        OnboardingPage2,
        OnboardingPage3,
        OnboardingPage4,
        OnboardingPage5,
        OnboardingPage6,
        OnboardingPage7,
        OnboardingPage8,
        OnboardingPage9,
        OnboardingPage10,
        OnboardingPage11,
        OnboardingPage12
      ],
      // The cumulative onboarding data from all steps.
      onboarding_data: {} /* ml_company_onboarding */
    }
  },
  computed: {
    current_page_component() {
      return this.pages[this.current_page_index]
    },
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'companies', 'periods', 'settings', 'sid']),

  },
  async mounted() {
    await this.load_onboarding_company();
    await this.load_company();
  },
  methods: {
    update_data(page_data) {
      if (page_data) {
        this.current_onboarding_company.onboarding_data = page_data;

        axios.put(`/onboarding/company/${this.current_onboarding_company.id}`, this.current_onboarding_company);
      }
    },
    next_page() {
      this.current_page_index++
    },
    async finished(data) {
      this.current_onboarding_company.onboarding_data = data;
      this.current_onboarding_company.status = 'DONE';

      const res = await axios.put(`/onboarding/company/${this.current_onboarding_company.id}`, this.current_onboarding_company);

      if (res.status === 204) {
        this.done_onboarding_company = this.current_onboarding_company;
      }
      
    },
    prev_page() {
      this.current_page_index--
    },

    async load_company() {
      const res = await axios.get(`/company/admin?company_id=${this.sid}`)
  
      if (res.status === 200) {
        this.company = res.data;
        this.registration = { ...this.company.registration };
      }
    },

    async load_onboarding_company() {
      const res = await axios.get(`/onboarding/company/list/${this.currentCompanyId}`)
  
      if (res.status === 200) {
        this.current_onboarding_company = res.data.find(i => i.status !== 'DONE');
        this.done_onboarding_company = res.data.find(i => i.status === 'DONE');

        if (!this.current_onboarding_company && !this.done_onboarding_company) {
          // first time, so we need to create onboarding
          const res2 = await axios.post(`/onboarding/company/${this.currentCompanyId}`, {});

          if (res2.status === 201) {
            this.current_onboarding_company = res2.data;
          }
        }
      }
    },
    
  }
}
</script>

